<template>
  <div class="D2Form">
    <header class="D2Form-header">
      <img :src="ref.icon" alt="">
      <h1>{{ ref.title }}</h1>
    </header>
    <main class="D2Form-body">
      <header class="D2Form-body-header">
        <Row type="flex" justify="center">
          <Col>
            <button class="D2Form-body-header-item" :class="{'is-visiting': $store.state.ui.pageCat === 1, 'has-visited': $store.state.ui.pageCat > 1}">
              <img src="/assets/i-identificacao.png" alt="">
              Identificacao
            </button>
          </Col>
        </Row>
      </header>
      <div class="D2Form-body-content" id="content">
        <Pages ref="pages">
          <Page :category="1" :n="1">
            <h2 class="D2Form-body-title">Dados iniciais</h2>
            <div class="D2Form-input">
              <Icon type="ios-person-outline"></Icon>
              <Input v-model="form.identificacao.nome" placeholder="Digite o seu nome"></Input>
            </div>
            <div class="D2Form-input" :class="{'is-invalid': validateEmail}">
              <Icon type="ios-mail-outline" />
              <Input v-model="form.identificacao.email" placeholder="Digite o seu email" @on-change="ui.inputsDirty.email = true"></Input>
            </div>
            <div class="D2Form-input">
              <Icon type="ios-call-outline" />
              <Input v-model="form.identificacao.telefone" placeholder="Digite um telefone para contato" @on-keyup="maskPhone()"></Input>
            </div>

            <div class="D2Form-input">
              <i-switch v-model="form.identificacao.newsletter" size="small"></i-switch>
              <span style="color: rgb(187, 190, 196);margin-left:.5em;">
                Desejo receber informações, promoções e novidades da D2 <small style="opacity: .7;">não gostamos de spam ;)</small>
              </span>
            </div>

            <h2 class="D2Form-body-title" style="margin-top: 10vh">Informações Básicas</h2>

            <Choices v-model="form.informacoes_basicas.tem_site" style="margin-bottom: 5vh;">
                <Choice label="não" img="/assets/choice-design.png" title="Não tenho site">
                  Criar um novo site responsivo com uma nova identidade.
                </Choice>
                <Choice label="sim" img="/assets/choice-redesign.png" title="Tenho site e quero mudar">
                  Repaginar um site antigo, aproveitando o conteúdo do site anterior.
                </Choice>
            </Choices>

            <div class="D2Form-input" v-show="form.informacoes_basicas.tem_site === 'sim'" style="margin-bottom: 5vh;">
              <Icon type="md-link"></Icon>
              <Input v-model="form.site_info.endereco" placeholder="Endereço do site"></Input>
            </div>

            <button @click="finish" class="D2Form-btn D2Form-btn--finish u-icon--right" :class="[`btn-finalizar--${lead.formState}`, {'is-disabled': !validateLead}]">
              <span v-show="lead.formState === 0">Finalizar <Icon type="md-checkmark" /></Icon></span>
              <span v-show="lead.formState === 1">Finalizando <Icon type="ios-loading" /></Icon></span>
              <span v-show="lead.formState === 2">Finalizado <Icon type="md-checkmark" /></Icon></span>
            </button>
          </Page>

          <Page :n="2" :category="1">
            <h2 class="D2Form-body-title">Enviado</h2>

            <h4 class="D2Form-body-subtitle">Legal, {{form.identificacao.nome.split(' ')[0]}}, ficamos feliz pelo seu interesse e para essa primeira parte já temos o que precisamos. Nossa equipe entrará em contato em até 1 dia útil. =)
            </h4>

            <button @click="finish" class="D2Form-btn D2Form-btn--finish u-icon--right" :class="[`btn-finalizar--${lead.formState}`, {'is-disabled': !validateLead}]">
              <span v-show="lead.formState === 0">Finalizar <Icon type="md-checkmark" /></Icon></span>
              <span v-show="lead.formState === 1">Finalizando <Icon type="ios-loading" /></Icon></span>
              <span v-show="lead.formState === 2">Finalizado <Icon type="md-checkmark" /></Icon></span>
            </button>
          </Page>

        </Pages>
      </div>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
import is from 'is_js'
import VMasker from 'vanilla-masker'
import queryString from 'query-string'
import filter from 'lodash-es/filter'

import Page from '@/components/Page.vue'
import Pages from '@/components/Pages.vue'
import Choice from '@/components/Choice.vue'
import Choices from '@/components/Choices.vue'
import ButtonsFooter from '@/components/ButtonsFooter.vue'

export default {
  name: 'Home',
  data () {
    return {
      lead: {
        sent: false,
        formState: 0,
      },
      readyToSend: false,
      ui: {
        inputsDirty: {
          email: false
        },
        referencia: {
          nome: '',
          endereco: ''
        },
        dateOptions: {
          shortcuts: [
            {
              text: '3 semanas',
              value () {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 7 * 3);
                return date;
              },
            },
            {
              text: '1 mês',
              value () {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                return date;
              },
            },
            {
              text: '2 meses',
              value () {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 24 * 30 * 2);
                return date;
              },
            },
          ],
          disabledDate (date) {
            const currentDate = new Date(date)
            const availableDate = new Date()

            return date < availableDate.setTime(availableDate.getTime() + 3600 * 1000 * 24 * 7 * 3)
          }
        }
      },
      form: {
        identificacao: {
          nome: '',
          email: '',
          newsletter: true
        },
        informacoes_basicas: {
          tem_site: ''
        },
        site_info: {
          endereco: ''
        },
        referencias: [],
        projeto: {
          personalidade: [],
          proposito: [],
          funcionalidade: [],
          calltoaction: [],
        },
        ref: '',
        audiencia: {},
        info_final: {
          segmento: '',
          descricao: '',
          deadline: {
            flexivel: true
          }
        }
      }
    }
  },
  watch: {
    '$store.state.ui.page_n': function (n) {
      if (n === 11) {
        this.readyToSend = true
        this.$emit('sendPlease')
      }
    },
    form: {
      deep: true,
      handler: function (val) {
        this.$nextTick(function () {
          this.$store.commit('ui/update')
        })
      }
    }
  },
  components: {
    Pages,
    Page,
    Choice,
    Choices,
    ButtonsFooter
  },
  computed: {
    is () {
      return is
    },
    validateEmail () {
      return !is.email(this.form.identificacao.email) && this.ui.inputsDirty.email
    },
    validateLead () {
      if (this.form.identificacao.nome !== '' && is.email(this.form.identificacao.email)) {
        if (this.form.informacoes_basicas.tem_site == 'não') {
          return true
        } else if (this.form.informacoes_basicas.tem_site == 'sim' && this.form.site_info.endereco.length > 8) {
          return true
        }
      }

      return false
    },
    ref () {
      let ref = {}
      const refs = [
        {slug: 'site-completo-wordpress', title: 'SITE COMPLETO - WORDPRESS', icon: 'assets/header-icon.png'},
        {slug: 'site-estatico', title: 'SITE ESTÁTICO', icon: 'assets/header-icon.png'},
        {slug: 'criacao-de-layout', title: 'CRIAÇÃO DE LAYOUT', icon: 'assets/header-icon.png'},
      ]

      const query = queryString.parse(window.location.search)

      const refSlug = query.ref
      ref = filter(refs, ref => ref.slug === refSlug)[0]
      ref = ref ? ref : refs[0]

      return ref
    }
  },
  methods: {
    finish () {
      const vm = this

      if (this.validateLead) {
        this.lead.formState = 1

        if (this.lead.sent === false) {
          this.$axios.post('/save-lead', {
              ...vm.form
            })
            .then(function (response) {
              if (response.data.success) {
                vm.lead.formState = 2
                vm.lead.sent = true
                vm.$store.dispatch('ui/nextPage', 2)
              }
            })
            .catch(function (error) {
              vm.lead.formState = 2
              vm.lead.sent = true
              vm.$store.dispatch('ui/nextPage', 2)
              throw(error)
            })
        }
      }

      // window.setTimeout(() => {
      //   vm.lead.formState = 2
      //   vm.lead.sent = true
      //   vm.$store.dispatch('ui/nextPage', 2)
      // }, 7000)
    },
    checkValid (valid) {
      return valid
    },
    maskPhone () {
      const phone = this.form.identificacao.telefone || ''
      const phoneNumber = VMasker.toNumber(phone)
      const isMobilePhone = phoneNumber.length == 11
      const mask = isMobilePhone ? "(99) 9 9999-9999" : "(99) 9999-9999"
      this.form.identificacao.telefone = VMasker.toPattern(phoneNumber, mask)
    },

    addReferencia () {
      const { nome, endereco, obs } =  this.ui.referencia

      const isValid = nome.length && endereco.length

      if (isValid) {
        this.form.referencias.push({
          nome, endereco, obs
        })

        this.ui.referencia.nome = ''
        this.ui.referencia.endereco = ''
        this.ui.referencia.obs = ''
      }

    }
  },
  mounted () {
    const vm = this

    this.form.ref = this.ref.slug

    this.$store.commit('ui/init')
  }
}
</script>
